import LocalizedStrings from "react-localization";

export const mediaAllmappingsStrings = new LocalizedStrings({
  en: {
    title: "Media Mapping",
    resetFiltersButton: "Reset",
    mediaId: " Media Id",
    mediaLabel: "Media Label",
    DataProvider: "Data Provider",
    DisplayMediaType: "Display Media",
    NumberAllMediaMapping: "Total Mappings",
  },
  fr: {
    title: "Médias Mapping",
    resetFiltersButton: "Réinitialiser",
    mediaId: "Id Média",
    mediaLabel: "Libellé Média ",
    DataProvider: "Fournisseur de données",
    DisplayMediaType: "Display Média",
    NumberAllMediaMapping: "Total des Mappings",
  },
});
